import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/SectionTitle';
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from '@/components/ui/carousel';
import BooksService from '@/common/API/BooksService';
import BookPlaceholder from '@/components/BookPlaceholder';
import { Button } from '@/components/ui/button';
import { ArrowRightIcon } from '@radix-ui/react-icons';

const BooksPreview = () => {
  const [booksList, setBooksList] = useState([]);

  useEffect(() => {
    BooksService.all({
      page: 1,
      per_page: 7,
    }).then((res: any) => {
      console.log(res.data);
      setBooksList(res?.data);
    });
  }, []);

  return (
    <article className='mt-4'>
      <div className='flex justify-between items-center mb-2'>
        <SectionTitle className='text-white' label='Books' />
        <Button asChild className='text-xs' size='sm' variant='ghost'>
          <Link to='/books'>View more</Link>
        </Button>
      </div>
      <Carousel>
        <CarouselContent>
          {booksList.map((book: any) => {
            return (
              <CarouselItem key={book?.id} className='basis-1/3 '>
                <Link to={`/books/${book?.id}`}>
                  <section className='bg-card  rounded-lg'>
                    <div className='h-[150px] flex items-center justify-center'>
                      {book?.image ? (
                        <img src={book?.image?.url} className='rounded-t-lg object-cover w-full h-full' alt='' />
                      ) : (
                        <BookPlaceholder />
                      )}
                    </div>
                    <span className='p-2 text-white/40 text-xs block truncate'>{book?.name}</span>
                  </section>
                </Link>
              </CarouselItem>
            );
          })}
          <CarouselItem key='books-more' className='basis-1/3 flex items-center'>
            <Button variant='ghost' className='rounded-full w-12 h-12'>
              <Link to='/books'>
                <ArrowRightIcon className='text-xl font-bold' />
              </Link>
            </Button>
          </CarouselItem>
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
      </Carousel>
    </article>
  );
};

export default BooksPreview;
